module.exports = "../images/perch.jpg?v=700960d";